import DefaultContainer from './Default';

export default DefaultContainer;